export function jsonLdScripts(...data: Array<Record<string, unknown> | null | undefined>) {
  return data.flatMap((value) =>
    value ? [{ type: "application/ld+json", children: JSON.stringify(value) }] : [],
  );
}
